import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/ChatImageView/lightboxSwipe.ts
import { useRef } from "react";
var DISMISS_DISTANCE_PX = 120;
var DISMISS_VELOCITY_PX_PER_MS = 0.5;
var FADE_DISTANCE_PX = 320;
var MIN_OPACITY = 0.4;
var VELOCITY_WINDOW_MS = 100;
function releaseVelocity(samples) {
  const last = samples.at(-1);
  if (!last) return 0;
  const first = samples.find((sample) => last.t - sample.t <= VELOCITY_WINDOW_MS) ?? last;
  return last.t > first.t ? (last.y - first.y) / (last.t - first.t) : 0;
}
function swipeDismisses(distance, velocity) {
  return distance >= DISMISS_DISTANCE_PX || distance > 0 && velocity >= DISMISS_VELOCITY_PX_PER_MS;
}
function dragOpacity(distance) {
  return Math.max(MIN_OPACITY, 1 - (1 - MIN_OPACITY) * distance / FADE_DISTANCE_PX);
}
var reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
function useSwipeToDismiss(panel, scrim, dismiss) {
  const dragRef = useRef(null);
  const touchesRef = useRef(/* @__PURE__ */ new Set());
  const paint = (distance) => {
    const opacity = String(dragOpacity(distance));
    for (const element of [panel(), scrim()]) {
      if (!element) continue;
      element.style.transition = "";
      element.style.opacity = opacity;
      element.style.setProperty("--buyscout-lightbox-from-opacity", opacity);
    }
    panel()?.style.setProperty("translate", `0 ${distance}px`);
  };
  const settle = () => {
    for (const element of [panel(), scrim()]) {
      if (!element) continue;
      element.style.transition = "translate var(--bs-lg-spring-smooth-duration) var(--bs-lg-spring-smooth), opacity var(--bs-lg-spring-smooth-duration) var(--bs-lg-spring-smooth)";
      element.style.removeProperty("translate");
      element.style.removeProperty("opacity");
      element.style.removeProperty("--buyscout-lightbox-from-opacity");
    }
  };
  const end = (event, release) => {
    touchesRef.current.delete(event.pointerId);
    const current = dragRef.current;
    if (!current || current.id !== event.pointerId) return;
    dragRef.current = null;
    if (current.axis !== "down") return;
    const distance = Math.max(0, event.clientY - current.startY);
    current.samples.push({ y: event.clientY, t: event.timeStamp });
    if (release && swipeDismisses(distance, releaseVelocity(current.samples))) dismiss();
    else if (!reducedMotion()) settle();
  };
  return {
    onPointerDown: (event) => {
      if (event.pointerType !== "touch") return;
      touchesRef.current.add(event.pointerId);
      if (touchesRef.current.size > 1) {
        if (dragRef.current?.axis === "down" && !reducedMotion()) settle();
        dragRef.current = null;
        return;
      }
      dragRef.current = { id: event.pointerId, startX: event.clientX, startY: event.clientY, samples: [{ y: event.clientY, t: event.timeStamp }] };
    },
    onPointerMove: (event) => {
      const current = dragRef.current;
      if (!current || current.id !== event.pointerId) return;
      const dx = event.clientX - current.startX;
      const dy = event.clientY - current.startY;
      if (!current.axis) {
        if (Math.hypot(dx, dy) < 8) return;
        current.axis = dy > Math.abs(dx) ? "down" : "other";
      }
      if (current.axis !== "down") return;
      current.samples.push({ y: event.clientY, t: event.timeStamp });
      if (current.samples.length > 20) current.samples.shift();
      if (!reducedMotion()) paint(Math.max(0, dy));
    },
    onPointerUp: (event) => end(event, true),
    onPointerCancel: (event) => end(event, false)
  };
}
export {
  dragOpacity,
  releaseVelocity,
  swipeDismisses,
  useSwipeToDismiss
};
//# sourceMappingURL=lightboxSwipe.mjs.map